import { render, staticRenderFns } from "./ParcelsSelection.vue?vue&type=template&id=7888ff3e&scoped=true&"
import script from "./ParcelsSelection.vue?vue&type=script&lang=ts&"
export * from "./ParcelsSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelsSelection.vue?vue&type=style&index=0&id=7888ff3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888ff3e",
  null
  
)

export default component.exports